export default "__VITE_ASSET__DOaISLmN__"